(function() {
  'use strict';

  const configurator = document.getElementById('raider-configurator');
  if (!configurator) return;
  const dataScript = document.getElementById('r20-data');
  if (!dataScript) return;

  let DATA;
  try {
    let rawText = dataScript.textContent.replace(/,\s*]/g, ']');
    DATA = JSON.parse(rawText);
  } catch (e) {
    console.error('Eroare parsare date R20:', e);
    return;
  }

  const state = {
    activeTool: null,
    selectedKit: null,
    selectedBattery: null,
    selectedCharger: null,
    selectedAccessory: null,
    kitQuantity: 1,
    batteryQuantity: 1,
    chargerQuantity: 1,
    accessoryQuantity: 1
  };

  const formatPrice = cents => (cents / 100).toFixed(2) + ' RON';

  function isAvailable(product) {
    if (!product || !product.variants || !product.variants.length) return false;
    return product.variants[0].available === true;
  }

  function getVariant(product) {
    return product && product.variants && product.variants.length ? product.variants[0] : null;
  }

  function getBatteryInfoFromTitle(title) {
    if (!title) return null;
    
    const matchTwo = title.match(/2x(\d+\.?\d*)Ah/i);
    if (matchTwo) {
      const capacity = matchTwo[1];
      const validCapacities = ['1.5', '2.0', '3.0', '4.0', '5.0', '6.0', '8.0', '12.0'];
      if (validCapacities.includes(capacity)) {
        return { count: 2, label: '2 acumulatori incluși' };
      }
    }
    
    const matchPlus = title.match(/(\d+\.?\d*)\s*\+\s*(\d+\.?\d*)Ah/i);
    if (matchPlus) {
      const cap1 = matchPlus[1];
      const cap2 = matchPlus[2];
      const validCapacities = ['1.5', '2.0', '3.0', '4.0', '5.0', '6.0', '8.0', '12.0'];
      if (validCapacities.includes(cap1) && validCapacities.includes(cap2)) {
        return { count: 2, label: '2 acumulatori incluși' };
      }
    }
    
    const matchOne = title.match(/(\d+\.?\d*)Ah/i);
    if (matchOne) {
      const capacity = matchOne[1];
      const validCapacities = ['1.5', '2.0', '3.0', '4.0', '5.0', '6.0', '8.0', '12.0'];
      if (validCapacities.includes(capacity)) {
        const prevChar = title.substring(matchOne.index - 2, matchOne.index);
        if (prevChar !== '2x') {
          return { count: 1, label: '1 acumulator inclus' };
        }
      }
    }
    
    return null;
  }

  function init() {
    configurator.innerHTML = `
      <div class="r20-header-intro">
        <h1>⚡ O baterie, o lume de posibilități</h1>
        <h2>Alege unealta, configurează-ți sistemul R20 cu acumulatori, încărcătoare și accesorii compatibile.</h2>
      </div>

      <div class="r20-search-container">
        <span class="r20-search-icon">🔍</span>
        <input type="text" id="r20-search-input" class="r20-search-input" placeholder="Caută rapid o unealtă (ex: polizor, bormașină)..." />
      </div>

      <div id="r20-collections-container"></div>
      
      <div class="r20-builder-overlay" id="r20-builder">
        <div class="r20-builder-content">
          <div class="r20-builder-header">
            <div>
              <h2 id="b-title">Sistem de alimentare</h2>
              <p id="b-desc"></p>
            </div>
            <button class="r20-close-builder" id="close-builder">Înapoi la Catalog</button>
          </div>
          <div class="r20-tree-container" id="r20-tree"></div>
          <div class="r20-builder-footer">
            <div class="r20-final-price">Total Pachet: <span id="b-total">0.00 RON</span></div>
            <button class="r20-btn-add" id="b-add">Adaugă Sistemul în Coș</button>
          </div>
        </div>
      </div>
    `;

    document.getElementById('r20-search-input').addEventListener('input', e => renderCollections(e.target.value));
    document.getElementById('close-builder').addEventListener('click', closeBuilder);
    document.getElementById('b-add').addEventListener('click', addToCart);

    // Ascultător unic pentru toate click-urile – înlocuiește inline onclick-urile
    configurator.addEventListener('click', function(e) {
      // CARDURI (produse principale)
      const card = e.target.closest('.r20-card');
      if (card && !card.classList.contains('r20-sold-out')) {
        const toolId = card.dataset.toolId;
        if (toolId) {
          e.preventDefault();
          window.r20SelectTool(Number(toolId));
          return;
        }
      }

      // ELEMENTE COMPATIBILE (accesorii din builder)
      const accItem = e.target.closest('.r20-acc-item');
      if (accItem && !accItem.classList.contains('r20-acc-sold-out')) {
        const type = accItem.dataset.type;
        const itemId = accItem.dataset.itemId;
        if (type && itemId) {
          e.preventDefault();
          window.r20SelectAcc(type, Number(itemId));
        }
      }
    });

    renderCollections();
  }

  function renderCollections(searchTerm = '') {
    const container = document.getElementById('r20-collections-container');
    const grouped = {};

    let filteredTools = DATA.tools;
    if (searchTerm) {
      const term = searchTerm.toLowerCase();
      filteredTools = filteredTools.filter(t => t.title.toLowerCase().includes(term));
    }

    filteredTools.forEach(tool => {
      if (tool.categories && tool.categories.length > 0) {
        tool.categories.forEach(cat => {
          if (!grouped[cat]) grouped[cat] = [];
          if (!grouped[cat].some(t => t.id === tool.id)) {
            grouped[cat].push(tool);
          }
        });
      } else {
        if (!grouped['Alte Echipamente']) grouped['Alte Echipamente'] = [];
        grouped['Alte Echipamente'].push(tool);
      }
    });

    let html = '';
    
    if (Object.keys(grouped).length === 0) {
      html = '<p style="text-align:center; font-size:1.4rem; color:#888; margin-top:2rem;">Nu am găsit nicio unealtă conform căutării tale.</p>';
    } else {
      const priorityCategories = [
        'Masini de gaurit si insurubat',
        'Masini de gaurit si insurubat cu percutie',
        'Ciocane rotopercutoare',
        'Polizoare unghiulare',
        'Fierastraie circulare',
        'Fierastraie pendulare',
        'Fierastraie sabie'
      ];

      const allCategories = Object.keys(grouped);
      const presentPriority = priorityCategories.filter(cat => allCategories.includes(cat));
      const otherCategories = allCategories.filter(cat => !priorityCategories.includes(cat) && cat !== 'Alte Echipamente');
      otherCategories.sort((a, b) => a.localeCompare(b));
      const sortedCats = [
        ...presentPriority,
        ...otherCategories,
        ...(allCategories.includes('Alte Echipamente') ? ['Alte Echipamente'] : [])
      ];

      for (const category of sortedCats) {
        const tools = grouped[category];
        html += `
          <div class="r20-collection-section">
            <h3 class="r20-collection-title">${category}</h3>
            <div class="r20-grid">
              ${tools.map(tool => {
                const variant = getVariant(tool);
                const available = variant ? variant.available : false;
                const soldOutClass = available ? '' : ' r20-sold-out';
                
                let reqBats = parseInt(tool.required_batteries, 10) || 1;
                let badgeText = `Necesită ${reqBats} acumulator${reqBats > 1 ? 'i' : ''}`;
                let badgeClass = reqBats > 1 ? 'r20-badge multiple' : 'r20-badge';

                const batteryInfo = getBatteryInfoFromTitle(tool.title);
                if (batteryInfo) {
                  reqBats = batteryInfo.count;
                  badgeText = batteryInfo.label;
                  badgeClass = 'r20-badge includes-battery';
                }
                
                return `
                  <div class="r20-card${soldOutClass}" data-tool-id="${tool.id}">
                    <div class="${badgeClass}">${badgeText}</div>
                    ${!available ? '<div class="r20-sold-out-badge">Stoc epuizat</div>' : ''}
                    <div class="r20-card-image"><img src="${tool.image || ''}" loading="lazy"></div>
                    <div class="r20-card-body">
                      <h4 class="r20-card-title">${tool.title}</h4>
                      <div class="r20-card-price">${formatPrice(variant ? variant.price : 0)}</div>
                    </div>
                  </div>
                `;
              }).join('')}
            </div>
          </div>
        `;
      }
    }
    
    container.innerHTML = html;
  }

  window.r20SelectTool = function(toolId) {
    const tool = DATA.tools.find(t => Number(t.id) === Number(toolId));
    if (!tool || !isAvailable(tool)) {
      alert('Acest produs nu este disponibil momentan.');
      return;
    }
    state.activeTool = tool;
    state.selectedKit = null;
    state.selectedBattery = null;
    state.selectedCharger = null;
    state.selectedAccessory = null;
    state.kitQuantity = 1;
    
    let reqBats = parseInt(tool.required_batteries, 10) || 1;
    const batteryInfo = getBatteryInfoFromTitle(tool.title);
    if (batteryInfo) {
      reqBats = batteryInfo.count;
    }
    state.batteryQuantity = Math.max(1, reqBats);
    
    state.chargerQuantity = 1;
    state.accessoryQuantity = 1;
    openBuilder();
  };

  function openBuilder() {
    document.getElementById('r20-builder').classList.add('active');
    document.body.style.overflow = 'hidden';
    
    let reqBats = parseInt(state.activeTool.required_batteries, 10) || 1;
    const batteryInfo = getBatteryInfoFromTitle(state.activeTool.title);
    if (batteryInfo) {
      reqBats = batteryInfo.count;
    }
    
    document.getElementById('b-title').textContent = state.activeTool.title;
    document.getElementById('b-desc').textContent = `Pentru performanțe optime, acest echipament necesită prezența simultană a ${reqBats} ${reqBats === 1 ? 'acumulator compatibil' : 'acumulatori compatibili'}. Te rugăm să îți configurezi pachetul alegând accesoriile necesare. Poți selecta elemente din oricare categorie.`;
    
    renderTree();
    updateTotal();
  }

  function closeBuilder() {
    document.getElementById('r20-builder').classList.remove('active');
    document.body.style.overflow = '';
  }

  function renderTree() {
    const tree = document.getElementById('r20-tree');
    const tool = state.activeTool;

    const safeKitIds = Array.isArray(tool.kit_ids) ? tool.kit_ids.map(Number) : [];
    const safeBattIds = Array.isArray(tool.battery_ids) ? tool.battery_ids.map(Number) : [];
    const safeChargerIds = Array.isArray(tool.charger_ids) ? tool.charger_ids.map(Number) : [];
    const safeAccessoryIds = Array.isArray(tool.accessory_ids) ? tool.accessory_ids.map(Number) : [];

    const compatKits = safeKitIds.length > 0 ? DATA.kits.filter(k => safeKitIds.includes(Number(k.id))) : DATA.kits;
    const compatBatts = safeBattIds.length > 0 ? DATA.batteries.filter(b => safeBattIds.includes(Number(b.id))) : DATA.batteries;
    const compatChargs = safeChargerIds.length > 0 ? DATA.chargers.filter(c => safeChargerIds.includes(Number(c.id))) : DATA.chargers;
    const compatAccessories = safeAccessoryIds.length > 0 ? DATA.accessories.filter(a => safeAccessoryIds.includes(Number(a.id))) : null;

    let html = `<div class="r20-tier-accessories">`;
    html += renderColumn('Kituri de bază', compatKits, 'kit');
    html += renderColumn('Acumulatori R20', compatBatts, 'battery');
    html += renderColumn('Stații de încărcare', compatChargs, 'charger');
    if (compatAccessories && compatAccessories.length > 0) {
      html += renderColumn('Accesorii compatibile', compatAccessories, 'accessory');
    }
    html += `</div>`;

    html += `
      <div class="r20-tier-tool">
        <div class="r20-core-tool">
          <img src="${tool.image || ''}">
          <h3>${tool.title}</h3>
          <div style="font-weight: 900; font-size: 1.6rem; color: var(--r20-red);">${formatPrice(getVariant(tool).price)}</div>
        </div>
      </div>
    `;

    tree.innerHTML = html;

    tree.querySelectorAll('.r20-qty-btn-small').forEach(btn => {
      btn.addEventListener('click', function(e) {
        e.stopPropagation();
        const type = this.dataset.type;
        const action = this.dataset.action;
        const qtyKey = `${type}Quantity`;
        let qty = state[qtyKey] || 1;
        if (action === 'increment') qty++;
        else if (action === 'decrement') qty = Math.max(1, qty - 1);
        state[qtyKey] = qty;
        const parent = this.closest('.r20-acc-item');
        const qtySpan = parent.querySelector('.r20-item-qty');
        if (qtySpan) qtySpan.textContent = qty;
        updateTotal();
      });
    });
  }

  function renderColumn(title, items, type) {
    if (!items || !items.length) return '';
    const itemsHtml = items.map(item => {
      const isSelected = state[`selected${capitalize(type)}`]?.id === item.id;
      const available = isAvailable(item);
      const soldOutLabel = available ? '' : ' <span style="color:#d32f2f; font-weight:700;">(Stoc epuizat)</span>';
      
      const qtyKey = `${type}Quantity`;
      const currentQty = state[qtyKey] || 1;
      
      return `
        <div class="r20-acc-item ${isSelected ? 'selected' : ''} ${!available ? 'r20-acc-sold-out' : ''}" 
             data-type="${type}" data-item-id="${item.id}">
          <img src="${item.image || ''}">
          <div class="r20-acc-item-info">
            <h4>${item.title}${soldOutLabel}</h4>
            <div class="price">${formatPrice(getVariant(item).price)}</div>
            ${isSelected && available ? `
              <div class="r20-item-qty-control">
                <button class="r20-qty-btn-small" data-type="${type}" data-action="decrement">−</button>
                <span class="r20-item-qty">${currentQty}</span>
                <button class="r20-qty-btn-small" data-type="${type}" data-action="increment">+</button>
              </div>
            ` : ''}
          </div>
        </div>
      `;
    }).join('');

    return `
      <div class="r20-acc-column">
        <div class="r20-acc-title-box">${title}</div>
        <div class="r20-acc-list">${itemsHtml}</div>
      </div>
    `;
  }

  window.r20SelectAcc = function(type, itemId) {
    const key = `selected${capitalize(type)}`;
    const sourceData = type === 'kit' ? DATA.kits : type === 'battery' ? DATA.batteries : type === 'charger' ? DATA.chargers : DATA.accessories;
    const item = sourceData.find(i => Number(i.id) === Number(itemId));
    if (!item || !isAvailable(item)) {
      alert('Acest produs nu este disponibil momentan.');
      return;
    }

    if (state[key] && Number(state[key].id) === Number(item.id)) {
      state[key] = null;
    } else {
      state[key] = item;
      const qtyKey = `${type}Quantity`;
      state[qtyKey] = 1;
    }
    
    renderTree();
    updateTotal();
  };

  function updateTotal() {
    let total = getVariant(state.activeTool).price;

    if (state.selectedKit) total += getVariant(state.selectedKit).price * (state.kitQuantity || 1);
    if (state.selectedBattery) total += getVariant(state.selectedBattery).price * (state.batteryQuantity || 1);
    if (state.selectedCharger) total += getVariant(state.selectedCharger).price * (state.chargerQuantity || 1);
    if (state.selectedAccessory) total += getVariant(state.selectedAccessory).price * (state.accessoryQuantity || 1);

    document.getElementById('b-total').textContent = formatPrice(total);
  }

  function capitalize(s) { return s.charAt(0).toUpperCase() + s.slice(1); }

  async function addToCart() {
    const checkAvailability = (product) => {
      if (!product) return true;
      return isAvailable(product);
    };

    if (!checkAvailability(state.activeTool)) {
      alert('Unealta selectată nu este disponibilă.');
      return;
    }
    if (!checkAvailability(state.selectedKit)) {
      alert('Kitul selectat nu este disponibil.');
      return;
    }
    if (!checkAvailability(state.selectedBattery)) {
      alert('Acumulatorul selectat nu este disponibil.');
      return;
    }
    if (!checkAvailability(state.selectedCharger)) {
      alert('Stația de încărcare selectată nu este disponibilă.');
      return;
    }
    if (!checkAvailability(state.selectedAccessory)) {
      alert('Accesoriul selectat nu este disponibil.');
      return;
    }

    const items = [
      { id: getVariant(state.activeTool).id, quantity: 1 }
    ];
    
    if (state.selectedKit) items.push({ id: getVariant(state.selectedKit).id, quantity: state.kitQuantity || 1 });
    if (state.selectedBattery) items.push({ id: getVariant(state.selectedBattery).id, quantity: state.batteryQuantity || 1 });
    if (state.selectedCharger) items.push({ id: getVariant(state.selectedCharger).id, quantity: state.chargerQuantity || 1 });
    if (state.selectedAccessory) items.push({ id: getVariant(state.selectedAccessory).id, quantity: state.accessoryQuantity || 1 });

    const btn = document.getElementById('b-add');
    btn.textContent = 'Procesare date...'; 
    btn.disabled = true;

    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items })
      });
      if (!res.ok) {
        const errorData = await res.json();
        throw new Error(errorData.message || 'Eroare necunoscută');
      }
      window.location.href = '/cart';
    } catch (e) {
      alert('Eroare la adăugarea în coș: ' + e.message);
      btn.textContent = 'Adaugă Sistemul în Coș';
      btn.disabled = false;
    }
  }

  init();
})();